import { actionCreator } from '@ardoq/rxbeach';
import type { ViewHoldPayload, ViewHoldReleasePayload } from './types';

export const activeViewRegistered = actionCreator<string>(
  '[activeViewsStatus] ACTIVE_VIEW_REGISTERED'
);

export const activeViewUnregistered = actionCreator<string>(
  '[activeViewsStatus] ACTIVE_VIEW_UNREGISTERED'
);

export const viewHoldTaken = actionCreator<ViewHoldPayload>(
  '[activeViewsStatus] VIEW_HOLD_TAKEN'
);

export const viewHoldReleased = actionCreator<ViewHoldReleasePayload>(
  '[activeViewsStatus] VIEW_HOLD_RELEASED'
);
